<template>
  <div class="mx-2">
    <div
      class="d-flex justify-content align-items-center mb-1 cursor-pointer mt-2"
      @click="goBackToList()">
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'">
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
    <div class="row">
      <div v-if="form.securityBoxTestingStatus.length" class="col-4">
        <div class="history-card card">
          <div class="history-header d-flex align-items-center justify-content-between">
            <strong>{{ $t('custom_forms.history') }}</strong>
            <small class="text-muted">
              {{ form.securityBoxTestingStatus.length }}
              {{ $t('custom_forms.entries') }}
            </small>
          </div>

          <div class="history-table">
            <div class="history-row history-row--head bg-transparent">
              <div class="col-state text-body">{{ $t('custom_forms.state') }}</div>
              <div class="col-user text-body">{{ $t('custom_forms.user') }}</div>
              <div class="col-date text-body">{{ $t('custom_forms.date') }}</div>
            </div>

            <div
              v-for="s in form.securityBoxTestingStatus"
              :key="s.id"
              class="history-row-item-container">
              <div class="history-row-item">
                <div class="col-state">
                  <b-badge pill :variant="getStatusVariant(s.status.name)" class="history-badge">
                    {{ getStatusLabel(s.status.name) }}
                  </b-badge>
                </div>
                <div class="col-user">
                  <div class="history-user" :title="formatUser(s)">
                    <div class="user-name text-body">{{ getUserName(s) || '—' }}</div>
                    <div v-if="getUserEmail(s)" class="user-email text-body">
                      {{ getUserEmail(s) }}
                    </div>
                  </div>
                </div>
                <div class="col-date">
                  <small class="history-date text-body">
                    {{ formatDate(s.approved_at || s.rejected_at || s.reopened_at || s.created_at) }}
                  </small>
                </div>
              </div>
              <div class="history-row-item__comments">
                {{ s.comments || s.reopened_comments }}
              </div>
            </div>
          </div>
          <!-- <div class="text-muted small py-1">
            {{ $t('custom_forms.empty') }}
          </div> -->
        </div>
      </div>
      <div :class="form.securityBoxTestingStatus.length ? 'col-8 form-container' : 'col-12'">
        <b-card class="" no-body>
          <div class="mt-2">
            <h4 class="mb-2 ml-1">{{ $t("testing.security_box.title") }}</h4>
          </div>
          <div class="header-grid mb-1 ml-2">
            <div class="info-card">
              <div class="info-row">
                <span class="info-label">{{ $t("risk.reference_number") }}:</span>
                <span class="info-value">{{ referenceShowed }}</span>
              </div>
            </div>
          </div>

          <div class="p-1">
            <div class="w-100">
              <b-alert
                class="p-1"
                :show="showAlert"
                variant="danger"
              >
                La REMS seleccionada tiene una prueba pendiente
              </b-alert>
              <b-form-group
                class="labelForSelect ml-1"
                :label="$tc('unit.title', 1)">
                <v-select
                  v-model="form.rems.facility"
                  :options="formattedFacilityOptions"
                  :filterable="false"
                  :multiple="false"
                  :clearable="true"
                  ref="selectable"
                  @search="onSearchFacility"
                  class="w-100"
                  :disabled="isFormDisabled || unitFieldDisabled"
                  @input="onChangeFacilitySelect"
                />
              </b-form-group>
              <div class="ml-2">
                <b-form-group
                  class="labelForSelect ml-1 w-50"
                  label="REMS">
                  <b-form-input
                    id="rems_facility"
                    v-model="form.rems.rems"
                    disabled
                  />
                </b-form-group>
                <b-form-group
                  class="labelForSelect ml-1 w-50"
                  label="SIRH">
                  <b-form-input
                    id="sirh_facility"
                    v-model="form.rems.sirh"
                    disabled
                  />
                </b-form-group>
                <span v-if="errors.rems" class="text-error">
                  {{ errors.rems }}
                </span>
              </div>
            </div>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Fecha registro">
                <flat-pickr
                  id="registrationDate"
                  v-model="form.registrationDate"
                  :config="datePickerConfig"
                  :disabled="isFormDisabled"
                  class="timeNoBackground w-100"
                />
                <span v-if="errors.registrationDate" class="text-error">
                  {{ errors.registrationDate }}
                </span>
              </b-form-group>
            </div>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="REQU de la prueba">
                <b-form-input
                  id="testRequ"
                  autocomplete="off"
                  v-model="form.testRequ"
                  :disabled="isFormDisabled"
                />
                <span v-if="errors.testRequ" class="text-error">
                  {{ errors.testRequ }}
                </span>
              </b-form-group>
            </div>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Descripción detallada">
                <b-form-textarea
                  rows="3"
                  max-rows="6"
                  v-model="form.detailedDescription"
                  :disabled="isFormDisabled"
                ></b-form-textarea>
                <span v-if="errors.detailedDescription" class="text-error">
                  {{ errors.detailedDescription }}
                </span>
              </b-form-group>
            </div>

            <div class="mb-3">
              <b-form-group
                class="labelForSelect ml-1 groupContainer"
                label="Responsable de Seguridad Física">
                <div class="groupContainer d-flex justify-content-center align-items-start" v-for="(manager, index) in form.physicalSecurityManager" :key="index+'manager'">
                  <div class="w-100">
                    <b-form-group
                      class="labelForSelect ml-1"
                      label="Puesto">
                      <b-form-input
                        :id="'physicalSecurityManagerProfile'+index"
                        autocomplete="off"
                        v-model="manager.profile"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1"
                      label="Nombre">
                      <b-form-input
                        id="physicalSecurityManagerName"
                        autocomplete="off"
                        v-model="manager.name"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1"
                      label="SOEID">
                      <b-form-input
                        id="physicalSecurityManageroeid"
                        autocomplete="off"
                        v-model="manager.soeid"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                  </div>
                  <!-- <b-button
                    @click="removeUserItem('physicalSecurityManager', index)"
                    size="sm"
                    variant="outline-danger"
                    class="ml-1">
                    {{ $t("actions.delete") }}
                  </b-button> -->
                </div>
                <div class="">
                  <span v-if="errors.physicalSecurityManager" class="text-error">
                    {{ errors.physicalSecurityManager }}
                  </span>
                </div>
                <!-- <b-button
                  @click="addNewUserItem('physicalSecurityManager')"
                  size="sm"
                  variant="outline-info">
                  + {{ $t("testing.security_box.manager") }}
                </b-button> -->
              </b-form-group>
            </div>

            <div class="mb-3">
              <b-form-group
                class="labelForSelect ml-1 groupContainer"
                label="Participantes de CCB">
                <div class="groupContainer d-flex justify-content-center align-items-start" v-for="(participant, index) in form.ccbParticipants" :key="index+'participant'">
                  <div class="w-100">
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="Puesto">
                      <b-form-input
                        id="ccbParticipantsProfile"
                        autocomplete="off"
                        v-model="participant.profile"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="Nombre">
                      <b-form-input
                        id="ccbParticipantsName"
                        autocomplete="off"
                        v-model="participant.name"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="SOEID">
                      <b-form-input
                        id="ccbParticipantsSoeid"
                        autocomplete="off"
                        v-model="participant.soeid"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                  </div>
                  <b-button
                    v-if="!isFormDisabled"
                    @click="removeUserItem('ccbParticipants', index)"
                    size="sm"
                    variant="outline-danger"
                    class="ml-1"
                    :disabled="isFormDisabled"
                  >
                    {{ $t("actions.delete") }}
                  </b-button>
                </div>
                <div class="">
                  <span v-if="errors.ccbParticipants" class="text-error">
                    {{ errors.ccbParticipants }}
                  </span>
                </div>
                <b-button
                  v-if="!isFormDisabled"
                  @click="addNewUserItem('ccbParticipants')"
                  size="sm"
                  variant="outline-info"
                  class="ml-1"
                  :disabled="isFormDisabled"
                >
                  + {{ $t("testing.penetration.participant") }}
                </b-button>
              </b-form-group>
            </div>

            <div class="mb-3">
              <b-form-group
                class="labelForSelect ml-1 groupContainer"
                label="Participantes de Sucursal">
                <div class="groupContainer d-flex justify-content-center align-items-start" v-for="(branchParticipant, index) in form.branchParticipants" :key="index+'branchParticipants'">
                  <div class="w-100">
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="Puesto">
                      <b-form-input
                        id="branchParticipantProfile"
                        autocomplete="off"
                        v-model="branchParticipant.profile"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="Nombre">
                      <b-form-input
                        id="branchParticipantName"
                        autocomplete="off"
                        v-model="branchParticipant.name"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      class="labelForSelect ml-1 w-50"
                      label="SOEID">
                      <b-form-input
                        id="branchParticipantSoeid"
                        autocomplete="off"
                        v-model="branchParticipant.soeid"
                        :disabled="isFormDisabled"
                      />
                    </b-form-group>
                  </div>
                  <b-button
                    v-if="!isFormDisabled"
                    @click="removeUserItem('branchParticipants', index)"
                    size="sm"
                    variant="outline-danger"
                    class="ml-1"
                    :disabled="isFormDisabled"
                  >
                    {{ $t("actions.delete") }}
                  </b-button>
                </div>
                <div class="">
                  <span v-if="errors.branchParticipants" class="text-error">
                    {{ errors.branchParticipants }}
                  </span>
                </div>
                <b-button
                  v-if="!isFormDisabled"
                  @click="addNewUserItem('branchParticipants')"
                  size="sm"
                  variant="outline-info"
                  class="ml-1"
                  :disabled="isFormDisabled"
                >
                  + {{ $t("testing.penetration.participant") }}
                </b-button>
              </b-form-group>
            </div>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Resultados">
                <v-select
                  v-model="form.result"
                  :options="resultsOptions"
                  :filterable="false"
                  :multiple="false"
                  :clearable="true"
                  class="w-100"
                  :disabled="isFormDisabled"
                />
                <span v-if="errors.result" class="text-error">
                  {{ errors.result }}
                </span>
              </b-form-group>
            </div>

            <div v-if="form.result && form.result === 'Fallido'">
              <b-form-group
                class="labelForSelect ml-1"
                label="Acciones correctivas">
                <b-form-textarea
                  rows="3"
                  max-rows="6"
                  v-model="form.correctiveActions"
                  :disabled="isFormDisabled"
                ></b-form-textarea>
                <span v-if="errors.correctiveActions" class="text-error">
                  {{ errors.correctiveActions }}
                </span>
              </b-form-group>
            </div>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Agregar documentos adjuntos">
                <div class="upload-button-container flex-column align-items-start">
                  <b-button
                    variant="primary"
                    size="sm"
                    :disabled="isFormDisabled"
                    class="upload-button mb-1 cursor-pointer"
                  >
                    <feather-icon icon="UploadIcon" size="18" class="cursor-pointer"/>
                    <input
                      id="filesForPenetrationsTest"
                      type="file"
                      multiple
                      :disabled="isFormDisabled"
                      class="file-input cursor-pointer"
                      @change="handleFileChange"
                    />
                  </b-button>
                  <div class="d-flex mb-1">
                    <div
                      v-for="(file, index) in files"
                      :key="'files-' + index"
                      class="preview-container"
                    >
                      <div class="preview-content">
                        <feather-icon
                          icon="FileTextIcon"
                          size="70"
                        />
                        <button
                          @click="removeFile(index)"
                          class="remove-button"
                          :disabled="isFormDisabled"
                        >
                          &#10005;
                        </button>
                      </div>
                      <span>{{ file.name }}</span>
                    </div>
                    <template v-if="showExistingFilesEdit">
                      <div
                        v-for="(file, index) in existingFiles"
                        :key="'existing-' + index"
                        class="preview-container"
                      >
                        <div class="preview-content">
                          <feather-icon
                            icon="FileTextIcon"
                            size="70"
                          />
                          <button
                            @click="removeExistingFile(index)"
                            class="remove-button"
                            :disabled="isFormDisabled"
                          >
                            &#10005;
                          </button>
                        </div>
                        <div class="text-center">
                          <a :href="file.url" download>
                            {{ file.name }}
                          </a>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-form-group>
            </div>

            <b-form-group
              v-if="showExistingFiles"
              :label="$t('testing.existingFiles')"
              class="ml-1"
            >
              <div class="row">
                <div class="col-6">
                  <b-list-group>
                    <b-list-group-item
                      v-for="(file, index) in existingFiles"
                      :key="'existing-' + index"
                      class="d-flex justify-content-between align-items-center"
                    >
                      {{ file.name }}
                      <a :href="file.url" download>
                        <feather-icon
                          icon="DownloadCloudIcon"
                          size="18"
                        />
                      </a>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </b-form-group>

            <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Acciones sugeridas posteriores al ejercicio">
                <b-form-textarea
                  rows="3"
                  max-rows="6"
                  v-model="form.suggestedActions"
                  :disabled="isFormDisabled"
                ></b-form-textarea>
              </b-form-group>
            </div>

           <!--  <div>
              <b-form-group class="ml-1" :label="$t('testing.maintenanceFormReference')">
                <b-form-input
                  id="rems_facility"
                  autocomplete="off"
                  v-model="form.maintenanceFormReference"
                  :disabled="isFormDisabled"
                />
              </b-form-group>
            </div> -->

            <!-- <div class="">
              <b-form-group
                class="labelForSelect ml-1"
                label="Aprobador">
                <b-form-input
                  id="approver"
                  v-model="form.approver"
                  disabled
                />
              </b-form-group>
            </div> -->
          </div>
          <div class="" v-if="showSaveButton">
            <b-button
              @click="submitForm"
              variant="info"
              class="ml-2 mb-2"
              :disabled="disabledButton"
            >
              {{ $t("actions.save") }}
            </b-button>
          </div>
          <!-- send to review btn -->
          <div class="px-2" v-if="canUserSendToReopen">
            <v-select
              v-model="userSelectedReasigned"
              :options="userReopenedOptions"
              :placeholder="$t('custom_forms.reassigned_to')"
              :reduce="(user) => user.id"
              class="comment-box mb-1"
              :filter-by="filterUsers"
              :get-option-label="getUserLabel"
            >
              <template v-slot:option="option">
                {{ option.user }} - {{ option.full_name }}
              </template>
            </v-select>
            <b-button
              variant="warning"
              class="ml-auto mb-3"
              :disabled="!userSelectedReasigned || disabledButton"
              @click="reopen()"
            >
              {{ $t("testing.reopenTest") }}
            </b-button>
          </div>
          <div class="px-2" v-if="canUserSendToReview">
            <v-select
              v-model="userSelected"
              :options="userOptions"
              :placeholder="$t('custom_forms.assigned_to')"
              :reduce="(user) => user.id"
              class="comment-box mb-1"
              :filter-by="filterUsers"
              :get-option-label="getUserLabel"
            >
              <template v-slot:option="option">
                {{ option.user }} - {{ option.full_name }}
              </template>
            </v-select>
            <b-button
              variant="warning"
              class="ml-auto mb-3"
              :disabled="!userSelected || disabledButton"
              @click="sendToReview()"
            >
              {{ $t("custom_forms.send_to_review") }}
            </b-button>
          </div>
          <div v-if="showValidateButtons" class="mb-1 px-2">
            <b-form-group
              class="text-capitalize"
              :label="$t('custom_forms.review_comments')"
              label-for="validation_comment"
            >
              <b-form-textarea
                class="comment-box"
                id="validation_comment"
                v-model="validationComment"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <span v-if="errorValidationComment" class="text-error">
                {{ errorValidationComment }}
              </span>
            </b-form-group>
            <div class="d-flex">
              <b-button
                variant="success"
                class="mr-1"
                :disabled="disabledButton"
                @click="approve()"
              >
                {{ $t("actions.approve") }}
              </b-button>
              <div
                class="d-flex"
              >
                <b-button
                  variant="danger"
                  :disabled="disabledButton"
                  @click="reject()"
                >
                  {{ $t("actions.reject") }}
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, getCurrentInstance, onMounted } from "@vue/composition-api";
import { useSecurityBoxForm } from './securityBoxForm';
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";

export default {
  name: "SecurityBoxForm",
  components: {
    vSelect,
    flatPickr
  },
  props: {
    dataToEdit: {
      default: null,
    }
  },
  setup(props, { emit, root }) {
    const vm = getCurrentInstance().proxy;

    const {
      form,
      isDark,
      formattedFacilityOptions,
      isFormDisabled,
      validationComment,
      datePickerConfig,
      referenceShowed,
      resultsOptions,
      existingFiles,
      formStatus,
      canUserSendToReview,
      errors,
      userOptions,
      userSelected,
      userSelectedReasigned,
      files,
      onSearchFacility,
      goBackToList,
      fetchFacilityData,
      addNewUserItem,
      removeUserItem,
      onChangeFacilitySelect,
      handleFileChange,
      removeFile,
      submitForm,
      setEditData,
      removeExistingFile,
      getValidators,
      sendToReview,
      approve,
      reject,
      showAlert,
      userReopenedOptions,
      reopen,
      errorValidationComment,
      getStatusVariant,
      getStatusLabel,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      getUsersReopened,
      disabledButton,
      formId,
      user,
      unitFieldDisabled
    } = useSecurityBoxForm(emit)

    onMounted(async () => {
      await getValidators();
      await getUsersReopened();

      fetchFacilityData()
      if(props.dataToEdit) {
        setEditData(props.dataToEdit)
      }
    });

    //COMPUTED
    const canUserSendToReopen = computed(() => {
      const userCanReopenPm =  vm.$can('reopen_pm', 'Testing');

      if (userCanReopenPm) {
        const conditionPmForm = (formStatus.value.inProgress || formStatus.value.isReview || formStatus.value.isReopen || formStatus.value.isRejected);

        return conditionPmForm;
      }

      const conditionReopen = formStatus.value.isRejected
      const userCanReopen   = vm.$can('reopen', 'Testing');
      const userOwnerValidationForm = (form.value.lastStatus && form.value.lastStatus.id_user_validation === user.id);

      return (conditionReopen && userCanReopen && userOwnerValidationForm);
    });

    const showValidateButtons = computed(() => {
      const formCondition  = formStatus.value.isReview;
      const userCanVlidate = vm.$can('validate', 'Testing');
      const userOwnerValidationForm = (form.value.lastStatus && form.value.lastStatus.id_user_validation === user.id);

      return (formCondition && userCanVlidate && userOwnerValidationForm);
    });

    const showExistingFiles = computed(() => (formStatus.value.isReview || formStatus.value.isApproved || formStatus.value.inProgress));

    const showExistingFilesEdit = computed(() => (formStatus.value.isReopen || formStatus.value.withoutValue));

    const showSaveButton = computed(() => {
      const disabledByStatuses = (formStatus.value.isReview || formStatus.value.isRejected || formStatus.value.isApproved || formStatus.value.isCanceled);
      const userCanCreate      = vm.$can('create', 'Testing');
      const userCanUpdate      = vm.$can('update', 'Testing');

      if (disabledByStatuses) {
        return false;
      } else if (formId.value) {
        return (userCanUpdate && !showAlert.value && (form.value.lastStatus && (user.id === form.value.lastStatus.id_user)));
      } else {
        return (!formStatus.value.withoutValue || formStatus.value.inProgress) && !showAlert.value && userCanCreate;
      }
    });

    //METHODS
    const filterUsers =(option, label, search) => {
      const text = search.toLowerCase()

      return (
        option.user?.toLowerCase().includes(text) ||
        option.full_name?.toLowerCase().includes(text)
      );
    }

    const getUserLabel = (option) => {
      return `${option.user} - ${option.full_name}`
    }

    return {
      form,
      isDark,
      formattedFacilityOptions,
      isFormDisabled,
      datePickerConfig,
      formStatus,
      resultsOptions,
      validationComment,
      referenceShowed,
      existingFiles,
      userSelected,
      userSelectedReasigned,
      canUserSendToReview,
      userOptions,
      files,
      errors,
      onSearchFacility,
      goBackToList,
      addNewUserItem,
      removeUserItem,
      onChangeFacilitySelect,
      handleFileChange,
      removeFile,
      submitForm,
      removeExistingFile,
      getValidators,
      sendToReview,
      showValidateButtons,
      approve,
      reject,
      showAlert,
      showSaveButton,
      userReopenedOptions,
      canUserSendToReopen,
      reopen,
      errorValidationComment,
      showExistingFiles,
      showExistingFilesEdit,
      getStatusVariant,
      getStatusLabel,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      disabledButton,
      filterUsers,
      getUserLabel,
      formId,
      user,
      unitFieldDisabled
    };
  },
};
</script>
<style lang="scss" scoped>
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
.groupContainer {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 5px;
  margin-bottom: 10px;
}
.text-error {
  color: #ec0303;
}
.form-container {
  height: calc(100vh - 150px);
  overflow: auto;
}

.comment-box {
  width: 450px;
}

/*info left, history right */
.header-grid {
  max-width: 850px;
}

@media (max-width: 992px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: #f9fafb;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-row {
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 600;
  color: #444;
}

.info-value {
  color: #111;
  text-transform: none !important;
}

.timeline-container {
  margin-top: 0.5rem;
  padding-left: 0;
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  padding-bottom: 1.5rem;
  cursor: pointer;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-item:hover:not(.active-form) {
  transform: translateX(2px);
}

.timeline-item.active-form {
  cursor: default;
}

.timeline-item.active-form .timeline-content {
  background: #e3f2fd;
  border-left: 3px solid #2196f3;
}

.timeline-dot {
  position: absolute;
  left: 5px;
  top: 6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #2196f3;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #2196f3;
}

.timeline-item.active-form .timeline-dot {
  background: #ff9800;
  box-shadow: 0 0 0 2px #ff9800;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 18px;
  bottom: 0;
  width: 2px;
  background: #e0e0e0;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-content {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.timeline-item:hover:not(.active-form) .timeline-content {
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.15);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.timeline-reference {
  font-weight: 600;
  color: #1976d2;
  font-size: 0.9rem;
}

.timeline-badge {
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.badge-mailable {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge-standard {
  background: #f5f5f5;
  color: #616161;
}

.timeline-template {
  font-size: 0.85rem;
  color: #333;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.timeline-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #666;
}

.timeline-container::-webkit-scrollbar {
  width: 6px;
}

.timeline-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.dark-layout {
  .info-card {
    background: #283046;
    border-color: #3b4253;
  }

  .info-label,
  .info-value {
    color: #b4b7bd;
  }

  .timeline-content {
    background: #283046;
    border-color: #3b4253;
  }

  .timeline-item:hover:not(.active-form) .timeline-content {
    border-color: #2196f3;
  }

  .timeline-item.active-form .timeline-content {
    background: #1e3a5f;
    border-left-color: #2196f3;
  }

  .timeline-reference {
    color: #64b5f6;
  }

  .timeline-template {
    color: #b4b7bd;
  }

  .timeline-meta {
    color: #8a8d93;
  }

  .badge-standard {
    background: #3b4253;
    color: #b4b7bd;
  }

  .timeline-container::-webkit-scrollbar-track {
    background: #161d31;
  }

  .timeline-container::-webkit-scrollbar-thumb {
    background: #555;
  }
}
.history-card { background: #fff; border: 1px solid #eceff3; border-radius: 8px; padding: 12px; overflow: hidden; min-width: 300px; }
.history-header { margin-bottom: 8px; }
.history-table { width: 100%; }
.history-row { display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;}
.history-row-item-container {
  border-bottom: 1px dotted #e0e0e0;
}
.history-row-item {  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;
  padding: 10px 0;
}
.history-row-item__comments {
  font-size: 16px;
}
.history-row:last-child { border-bottom: 0; }
.history-row--head { border-bottom: 1px solid #e9ecef; font-weight: 600; color: #444; padding-top: 0; padding-bottom: 8px; }
.col-state { justify-self: start; }
.col-user { justify-self: start; min-width: 0; }
.col-date { justify-self: end; white-space: nowrap; overflow: visible; }
.history-row--head > div, .history-row > .col-user { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.col-note { white-space: normal; overflow: hidden; }
.history-badge { display: inline-flex; align-items: center; }
.history-date { font-size: 12px; color: #6c757d; font-variant-numeric: tabular-nums; }
.content-grid { display: block; }
</style>
